export default __webpack_public_path__ + "static/media/works-img.7ace9190.png";